import { render, staticRenderFns } from "./ReviewReminder.vue?vue&type=template&id=2574bbea"
import script from "./ReviewReminder.vue?vue&type=script&lang=js"
export * from "./ReviewReminder.vue?vue&type=script&lang=js"
import style0 from "./ReviewReminder.vue?vue&type=style&index=0&id=2574bbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports